"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Divider = exports.Text = exports.ListItem = exports.List = exports.Group = exports.MobileContainer = exports.Container = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  font-family: 'Rubik';
  border-right: 1px solid #ccc;
  height: 100vh;
`;
exports.MobileContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 40px;
  #mobile-title {
    font-size: 28px;
  }
  #mobile-underline {
    margin: 15px 0 25px;
  }
  div {
    span {
      font-size: 21px;
    }
  }
  hr {
    width: 95%;
    background-color: #707070;
    opacity: 0.36;
  }
`;
exports.Group = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  align-items: center;
  justify-content: center;
  img {
    width: 35px;
  }
`;
exports.List = styled_components_1.default.ul `
  list-style: none;
  width: 100%;
  justify-content: end;
  display: flex;
`;
exports.ListItem = styled_components_1.default.li `
  padding: 0.2rem 0;
  cursor: pointer;
  padding-left: 20%;
  display: flex;
  align-items: center;
  border-right: ${(props) => (props.active ? '5px solid  #C31C4A' : 'none')};
`;
exports.Text = styled_components_1.default.span `
  margin-left: 10px;
  color: ${(props) => (props.active ? '#C31C4A' : '#000')};
`;
exports.Divider = styled_components_1.default.hr `
  width: 70%;
  margin: 1rem 10% 0.5rem auto;
`;
